import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserId, setUserProperties } from "firebase/analytics";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBoQXdL0TRJtNLtHR-zPWEDQ9LBXaG0Ox4",
  authDomain: "my-tassel.firebaseapp.com",
  projectId: "my-tassel",
  storageBucket: "my-tassel.appspot.com",
  messagingSenderId: "882425732978",
  appId: "1:882425732978:web:65d36b686a533d1ac607eb",
  measurementId: "G-7YPHD9TT5T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const db = getFirestore(app);

// Set persistence to local
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // 
  })
  .catch((error) => {
    
  });

const analytics = getAnalytics(app);

// Helper function to log analytics events
const logAnalyticsEvent = (eventName, eventParams = {}) => {
  try {
    logEvent(analytics, eventName, eventParams);
  } catch (error) {
    
  }
};

// Helper function to set user ID for analytics
const setAnalyticsUserId = (userId) => {
  try {
    setUserId(analytics, userId);
  } catch (error) {
    
  }
};

// Helper function to set user properties for analytics
const setAnalyticsUserProperties = (properties) => {
  try {
    setUserProperties(analytics, properties);
  } catch (error) {
    
  }
};

export { firebaseConfig, app, auth, db, analytics, logAnalyticsEvent, setAnalyticsUserId, setAnalyticsUserProperties };